import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import {
  Navbar,
  HeroSection,
  SocialProofBar,
  ProblemSolutionSection,
  FeaturesSection,
  IndustrySection,
  HowItWorksSection,
  PricingPreview,
  FAQSection,
  FinalCTA,
  Footer,
} from '../components/landing';
import { tokens } from '../theme';

const Landing: React.FC = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Chairs Up - see what your bar voided, by employee</title>
        <meta
          name="description"
          content="See every voided check on your Clover account, totalled and broken out by the employee who rang them, plus comps for employees where Clover said whether every line they rang had a discount."
        />
        <meta
          name="keywords"
          content="comps and voids, clover reporting, bar POS reporting, restaurant comps by employee, void tracking, clover analytics"
        />
        <meta property="og:title" content="Chairs Up - see what your bar voided, by employee" />
        <meta
          property="og:description"
          content="The money your bar voided away, and who rang it, plus comps for employees where Clover said whether every line they rang had a discount. Built on Clover."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://chairsup.com" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Chairs Up - see what your bar voided, by employee" />
        <meta
          name="twitter:description"
          content="The money your bar voided away, and who rang it, plus comps for employees where Clover said whether every line they rang had a discount."
        />
        <link rel="canonical" href="https://chairsup.com" />
      </Helmet>

      <Box
        sx={{
          minHeight: '100vh',
          background: tokens.background.default,
          overflowX: 'hidden',
        }}
      >
        {/* Navigation */}
        <Navbar />

        {/* Hero Section */}
        <Box id="hero">
          <HeroSection />
        </Box>

        {/* Social Proof */}
        <SocialProofBar />

        {/* Problem / Solution */}
        <ProblemSolutionSection />

        {/* Features */}
        <Box id="features">
          <FeaturesSection />
        </Box>

        {/* Industries */}
        <Box id="industries">
          <IndustrySection />
        </Box>

        {/* How It Works */}
        <HowItWorksSection />

        {/* Pricing Preview */}
        <Box id="pricing">
          <PricingPreview />
        </Box>

        {/* FAQ */}
        <Box id="faq">
          <FAQSection />
        </Box>

        {/* Final CTA */}
        <FinalCTA />

        {/* Footer */}
        <Footer />
      </Box>
    </>
  );
};

export default Landing;
